<template>
<div class="chapter">
<div class="inner_page">
<p class="C223"><a id="page_xviii"></a><a id="page_xix"><img alt="" class="Image103" src="html/images/18_1.png"/></a></p><a id="page_xix">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_The_Huxley_Family_Tree.vue?06817eac